// extracted by mini-css-extract-plugin
module.exports =  {"shortcuts-group":"shortcuts-group-lFLEk"};